/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChoiceInfoTypeConstants } from './ChoiceInfoTypeConstants';
import {
    ChoiceInfoTypeConstantsFromJSON,
    ChoiceInfoTypeConstantsFromJSONTyped,
    ChoiceInfoTypeConstantsToJSON,
} from './ChoiceInfoTypeConstants';

/**
 * 
 * @export
 * @interface ChoiceInfo
 */
export interface ChoiceInfo {
    /**
     * 
     * @type {string}
     * @memberof ChoiceInfo
     */
    title?: string;
    /**
     * 
     * @type {ChoiceInfoTypeConstants}
     * @memberof ChoiceInfo
     */
    choiceInfoType?: ChoiceInfoTypeConstants;
}

/**
 * Check if a given object implements the ChoiceInfo interface.
 */
export function instanceOfChoiceInfo(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ChoiceInfoFromJSON(json: any): ChoiceInfo {
    return ChoiceInfoFromJSONTyped(json, false);
}

export function ChoiceInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChoiceInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': !exists(json, 'title') ? undefined : json['title'],
        'choiceInfoType': !exists(json, 'choiceInfoType') ? undefined : ChoiceInfoTypeConstantsFromJSON(json['choiceInfoType']),
    };
}

export function ChoiceInfoToJSON(value?: ChoiceInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'choiceInfoType': ChoiceInfoTypeConstantsToJSON(value.choiceInfoType),
    };
}

